import { merge } from 'lodash';
import { Input } from './Input';
import { Radio } from './Radio';
import { Switch } from './Switch';
import { Select } from './Select';
import { Checkbox } from './Checkbox';
import { ControlLabel } from './ControlLabel'; // ----------------------------------------------------------------------

export var Form = function Form(_ref) {
  var theme = _ref.theme;
  return merge(Input({
    theme: theme
  }), Radio(), Switch({
    theme: theme
  }), Select(), Checkbox({
    theme: theme
  }), ControlLabel({
    theme: theme
  }));
};